import React from "react";
import styles from "./GalleriesDescriptionSection.module.scss";

const GalleriesDescriptionSection = () => {
  return (
    <div className={styles.galleriesDescriptionSection}>
      <h2 className={styles.title}>Our Galleries</h2>
      <p className={styles.description}>
        Contrary to popular belief, Lorem Ipsum is not simply random text. It
        has roots in a piece of classical Latin literature from 45 BC, making it
        over 2000 years old. Richard McClintock, a Latin professor at
        Hampden-Sydney College in Virginia, looked up one of the more obscure
        Latin words, consectetur, from a Lorem Ipsum passage, and going through
        the cites of the word in classical. Contrary to popular belief, Lorem
        Ipsum is not.
        <span>Become a Partner Gallery</span>
      </p>
    </div>
  );
};

export default GalleriesDescriptionSection;
